/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.5.6
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as runtime from '../runtime';
import { DocumentFromJSON, LocalAccountTypesToJSON, } from '../models';
/**
 *
 */
var DocumentsApi = /** @class */ (function (_super) {
    __extends(DocumentsApi, _super);
    function DocumentsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     */
    DocumentsApi.prototype.addDocumentRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, consumes, canConsumeForm, formParams, useForm, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4:
                        consumes = [
                            { contentType: 'multipart/form-data' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.propertyId !== undefined) {
                            formParams.append('PropertyId', requestParameters.propertyId);
                        }
                        if (requestParameters.workorderId !== undefined) {
                            formParams.append('WorkorderId', requestParameters.workorderId);
                        }
                        if (requestParameters.pMScheduleId !== undefined) {
                            formParams.append('PMScheduleId', requestParameters.pMScheduleId);
                        }
                        if (requestParameters.assetId !== undefined) {
                            formParams.append('AssetId', requestParameters.assetId);
                        }
                        if (requestParameters.partId !== undefined) {
                            formParams.append('PartId', requestParameters.partId);
                        }
                        if (requestParameters.vendorId !== undefined) {
                            formParams.append('VendorId', requestParameters.vendorId);
                        }
                        if (requestParameters.costId !== undefined) {
                            formParams.append('CostId', requestParameters.costId);
                        }
                        if (requestParameters.procedureId !== undefined) {
                            formParams.append('ProcedureId', requestParameters.procedureId);
                        }
                        if (requestParameters.fileName !== undefined) {
                            formParams.append('FileName', requestParameters.fileName);
                        }
                        if (requestParameters.document !== undefined) {
                            formParams.append('Document', requestParameters.document);
                        }
                        if (requestParameters.userFMRecordId !== undefined) {
                            formParams.append('User.FMRecordId', requestParameters.userFMRecordId);
                        }
                        if (requestParameters.userFMModId !== undefined) {
                            formParams.append('User.FMModId', requestParameters.userFMModId);
                        }
                        if (requestParameters.userUserId !== undefined) {
                            formParams.append('User.UserId', requestParameters.userUserId);
                        }
                        if (requestParameters.userContactId !== undefined) {
                            formParams.append('User.ContactId', requestParameters.userContactId);
                        }
                        if (requestParameters.userSubjectId !== undefined) {
                            formParams.append('User.SubjectId', requestParameters.userSubjectId);
                        }
                        if (requestParameters.userWorkerVendor !== undefined) {
                            formParams.append('User.WorkerVendor', requestParameters.userWorkerVendor);
                        }
                        if (requestParameters.userPropertyId !== undefined) {
                            formParams.append('User.PropertyId', requestParameters.userPropertyId);
                        }
                        if (requestParameters.userLoginName !== undefined) {
                            formParams.append('User.LoginName', requestParameters.userLoginName);
                        }
                        if (requestParameters.userProperNameDisplay !== undefined) {
                            formParams.append('User.ProperNameDisplay', requestParameters.userProperNameDisplay);
                        }
                        if (requestParameters.userEmailAddress !== undefined) {
                            formParams.append('User.EmailAddress', requestParameters.userEmailAddress);
                        }
                        if (requestParameters.userLocalAccountFlag !== undefined) {
                            formParams.append('User.LocalAccountFlag', new Blob([JSON.stringify(LocalAccountTypesToJSON(requestParameters.userLocalAccountFlag))], { type: "application/json", }));
                        }
                        if (requestParameters.userAssignToSecure !== undefined) {
                            formParams.append('User.AssignToSecure', requestParameters.userAssignToSecure);
                        }
                        if (requestParameters.userUserRole !== undefined) {
                            formParams.append('User.UserRole', requestParameters.userUserRole);
                        }
                        if (requestParameters.userCUserCanDos !== undefined) {
                            formParams.append('User.cUserCanDos', requestParameters.userCUserCanDos);
                        }
                        if (requestParameters.userCUserCanDoQualifiers !== undefined) {
                            formParams.append('User.cUserCanDoQualifiers', requestParameters.userCUserCanDoQualifiers);
                        }
                        if (requestParameters.userResourceOwnerTransitoryTag !== undefined) {
                            formParams.append('User.ResourceOwnerTransitoryTag', requestParameters.userResourceOwnerTransitoryTag);
                        }
                        if (requestParameters.userResetPasswordRequestTag !== undefined) {
                            formParams.append('User.ResetPasswordRequestTag', requestParameters.userResetPasswordRequestTag);
                        }
                        if (requestParameters.userMustChangePasswordNextLogon !== undefined) {
                            formParams.append('User.MustChangePasswordNextLogon', requestParameters.userMustChangePasswordNextLogon);
                        }
                        if (requestParameters.userCannotChangePassword !== undefined) {
                            formParams.append('User.CannotChangePassword', requestParameters.userCannotChangePassword);
                        }
                        if (requestParameters.userIsDisabled !== undefined) {
                            formParams.append('User.IsDisabled', requestParameters.userIsDisabled);
                        }
                        if (requestParameters.userOrderTimerWorkorderId !== undefined) {
                            formParams.append('User.OrderTimer.WorkorderId', requestParameters.userOrderTimerWorkorderId);
                        }
                        if (requestParameters.userOrderTimerUserId !== undefined) {
                            formParams.append('User.OrderTimer.UserId', requestParameters.userOrderTimerUserId);
                        }
                        if (requestParameters.userOrderTimerTimerStarted !== undefined) {
                            formParams.append('User.OrderTimer.TimerStarted', requestParameters.userOrderTimerTimerStarted);
                        }
                        if (requestParameters.userCustomFilterButtons) {
                            formParams.append('User.CustomFilterButtons', requestParameters.userCustomFilterButtons.join(runtime.COLLECTION_FORMATS["csv"]));
                        }
                        if (requestParameters.userInOutStatus !== undefined) {
                            formParams.append('User.InOutStatus', requestParameters.userInOutStatus);
                        }
                        if (requestParameters.userInOutDateTime !== undefined) {
                            formParams.append('User.InOutDateTime', requestParameters.userInOutDateTime);
                        }
                        if (requestParameters.userInOutActiveFlag !== undefined) {
                            formParams.append('User.InOutActiveFlag', requestParameters.userInOutActiveFlag);
                        }
                        if (requestParameters.userContactFMRecordId !== undefined) {
                            formParams.append('User.Contact.FMRecordId', requestParameters.userContactFMRecordId);
                        }
                        if (requestParameters.userContactFMModId !== undefined) {
                            formParams.append('User.Contact.FMModId', requestParameters.userContactFMModId);
                        }
                        if (requestParameters.userContactContactId !== undefined) {
                            formParams.append('User.Contact.ContactId', requestParameters.userContactContactId);
                        }
                        if (requestParameters.userContactPropertyId !== undefined) {
                            formParams.append('User.Contact.PropertyId', requestParameters.userContactPropertyId);
                        }
                        if (requestParameters.userContactFirstName !== undefined) {
                            formParams.append('User.Contact.FirstName', requestParameters.userContactFirstName);
                        }
                        if (requestParameters.userContactLastName !== undefined) {
                            formParams.append('User.Contact.LastName', requestParameters.userContactLastName);
                        }
                        if (requestParameters.userContactEmailAddress !== undefined) {
                            formParams.append('User.Contact.EmailAddress', requestParameters.userContactEmailAddress);
                        }
                        if (requestParameters.userContactPhone !== undefined) {
                            formParams.append('User.Contact.Phone', requestParameters.userContactPhone);
                        }
                        if (requestParameters.userContactCompany !== undefined) {
                            formParams.append('User.Contact.Company', requestParameters.userContactCompany);
                        }
                        if (requestParameters.userContactDepartmentCode !== undefined) {
                            formParams.append('User.Contact.DepartmentCode', requestParameters.userContactDepartmentCode);
                        }
                        if (requestParameters.userContactDepartmentName !== undefined) {
                            formParams.append('User.Contact.DepartmentName', requestParameters.userContactDepartmentName);
                        }
                        if (requestParameters.userContactTenantName !== undefined) {
                            formParams.append('User.Contact.TenantName', requestParameters.userContactTenantName);
                        }
                        if (requestParameters.userContactCampus !== undefined) {
                            formParams.append('User.Contact.Campus', requestParameters.userContactCampus);
                        }
                        if (requestParameters.userContactLocation1 !== undefined) {
                            formParams.append('User.Contact.Location1', requestParameters.userContactLocation1);
                        }
                        if (requestParameters.userContactFloor !== undefined) {
                            formParams.append('User.Contact.Floor', requestParameters.userContactFloor);
                        }
                        if (requestParameters.userContactLocation2 !== undefined) {
                            formParams.append('User.Contact.Location2', requestParameters.userContactLocation2);
                        }
                        if (requestParameters.userContactLocation3 !== undefined) {
                            formParams.append('User.Contact.Location3', requestParameters.userContactLocation3);
                        }
                        if (requestParameters.userWorkerFMRecordId !== undefined) {
                            formParams.append('User.Worker.FMRecordId', requestParameters.userWorkerFMRecordId);
                        }
                        if (requestParameters.userWorkerFMModId !== undefined) {
                            formParams.append('User.Worker.FMModId', requestParameters.userWorkerFMModId);
                        }
                        if (requestParameters.userWorkerWorkerId !== undefined) {
                            formParams.append('User.Worker.WorkerId', requestParameters.userWorkerWorkerId);
                        }
                        if (requestParameters.userWorkerSecureLaborId !== undefined) {
                            formParams.append('User.Worker.SecureLaborId', requestParameters.userWorkerSecureLaborId);
                        }
                        if (requestParameters.userWorkerPropertyId !== undefined) {
                            formParams.append('User.Worker.PropertyId', requestParameters.userWorkerPropertyId);
                        }
                        if (requestParameters.userWorkerWorkerName !== undefined) {
                            formParams.append('User.Worker.WorkerName', requestParameters.userWorkerWorkerName);
                        }
                        if (requestParameters.userWorkerHourlyRate !== undefined) {
                            formParams.append('User.Worker.HourlyRate', requestParameters.userWorkerHourlyRate);
                        }
                        if (requestParameters.userWorkerWorkerNotifyPref !== undefined) {
                            formParams.append('User.Worker.WorkerNotifyPref', requestParameters.userWorkerWorkerNotifyPref);
                        }
                        if (requestParameters.userWorkerWorkerNotes !== undefined) {
                            formParams.append('User.Worker.WorkerNotes', requestParameters.userWorkerWorkerNotes);
                        }
                        if (requestParameters.userWorkerEmailAddress !== undefined) {
                            formParams.append('User.Worker.EmailAddress', requestParameters.userWorkerEmailAddress);
                        }
                        if (requestParameters.userWorkerPhone !== undefined) {
                            formParams.append('User.Worker.Phone', requestParameters.userWorkerPhone);
                        }
                        if (requestParameters.userWorkerCellphone !== undefined) {
                            formParams.append('User.Worker.Cellphone', requestParameters.userWorkerCellphone);
                        }
                        if (requestParameters.userWorkerVendorId !== undefined) {
                            formParams.append('User.Worker.VendorId', requestParameters.userWorkerVendorId);
                        }
                        if (requestParameters.userWorkerVendorName !== undefined) {
                            formParams.append('User.Worker.VendorName', requestParameters.userWorkerVendorName);
                        }
                        if (requestParameters.userWorkerContact1Flag !== undefined) {
                            formParams.append('User.Worker.Contact1Flag', requestParameters.userWorkerContact1Flag);
                        }
                        if (requestParameters.userWorkerMasterRecordFlag !== undefined) {
                            formParams.append('User.Worker.MasterRecordFlag', requestParameters.userWorkerMasterRecordFlag);
                        }
                        if (requestParameters.userWorkerWorkerPersonnelId !== undefined) {
                            formParams.append('User.Worker.WorkerPersonnelId', requestParameters.userWorkerWorkerPersonnelId);
                        }
                        if (requestParameters.userWorkerSupervisorFlag !== undefined) {
                            formParams.append('User.Worker.SupervisorFlag', requestParameters.userWorkerSupervisorFlag);
                        }
                        if (requestParameters.userWorkerShifts !== undefined) {
                            formParams.append('User.Worker.Shifts', requestParameters.userWorkerShifts);
                        }
                        if (requestParameters.userWorkerBuildings !== undefined) {
                            formParams.append('User.Worker.Buildings', requestParameters.userWorkerBuildings);
                        }
                        if (requestParameters.userWorkerPager !== undefined) {
                            formParams.append('User.Worker.Pager', requestParameters.userWorkerPager);
                        }
                        if (requestParameters.userWorkerInOut !== undefined) {
                            formParams.append('User.Worker.InOut', requestParameters.userWorkerInOut);
                        }
                        if (requestParameters.userWorkerUserNameEntry !== undefined) {
                            formParams.append('User.Worker.UserNameEntry', requestParameters.userWorkerUserNameEntry);
                        }
                        if (requestParameters.userWorkerRoleEntry !== undefined) {
                            formParams.append('User.Worker.RoleEntry', requestParameters.userWorkerRoleEntry);
                        }
                        if (requestParameters.userWorkerLocationTrackingFlag !== undefined) {
                            formParams.append('User.Worker.LocationTrackingFlag', requestParameters.userWorkerLocationTrackingFlag);
                        }
                        if (requestParameters.userWorkerLocationTrackingDeviceNumber !== undefined) {
                            formParams.append('User.Worker.LocationTrackingDeviceNumber', requestParameters.userWorkerLocationTrackingDeviceNumber);
                        }
                        if (requestParameters.userWorkerIncludeDailyReportFlag !== undefined) {
                            formParams.append('User.Worker.IncludeDailyReportFlag', requestParameters.userWorkerIncludeDailyReportFlag);
                        }
                        if (requestParameters.userWorkerWorkerReAssignKey !== undefined) {
                            formParams.append('User.Worker.WorkerReAssignKey', requestParameters.userWorkerWorkerReAssignKey);
                        }
                        if (requestParameters.userWorkerCreatedDate !== undefined) {
                            formParams.append('User.Worker.CreatedDate', requestParameters.userWorkerCreatedDate);
                        }
                        if (requestParameters.userWorkerCreatedTime !== undefined) {
                            formParams.append('User.Worker.CreatedTime', requestParameters.userWorkerCreatedTime);
                        }
                        if (requestParameters.userWorkerCreatedBy !== undefined) {
                            formParams.append('User.Worker.CreatedBy', requestParameters.userWorkerCreatedBy);
                        }
                        if (requestParameters.userWorkerModifiedDate !== undefined) {
                            formParams.append('User.Worker.ModifiedDate', requestParameters.userWorkerModifiedDate);
                        }
                        if (requestParameters.userWorkerModifiedTime !== undefined) {
                            formParams.append('User.Worker.ModifiedTime', requestParameters.userWorkerModifiedTime);
                        }
                        if (requestParameters.userWorkerModifiedBy !== undefined) {
                            formParams.append('User.Worker.ModifiedBy', requestParameters.userWorkerModifiedBy);
                        }
                        if (requestParameters.userWorkerCreatedTimestamp !== undefined) {
                            formParams.append('User.Worker.CreatedTimestamp', requestParameters.userWorkerCreatedTimestamp);
                        }
                        if (requestParameters.userWorkerModifiedTimestamp !== undefined) {
                            formParams.append('User.Worker.ModifiedTimestamp', requestParameters.userWorkerModifiedTimestamp);
                        }
                        if (requestParameters.userWorkerJobRanks) {
                            formParams.append('User.Worker.JobRanks', requestParameters.userWorkerJobRanks.join(runtime.COLLECTION_FORMATS["csv"]));
                        }
                        if (requestParameters.userWorkerTradeDisplay !== undefined) {
                            formParams.append('User.Worker.TradeDisplay', requestParameters.userWorkerTradeDisplay);
                        }
                        if (requestParameters.userWorkerWorkerTrades) {
                            formParams.append('User.Worker.WorkerTrades', requestParameters.userWorkerWorkerTrades.join(runtime.COLLECTION_FORMATS["csv"]));
                        }
                        if (requestParameters.userWorkerTrades !== undefined) {
                            formParams.append('User.Worker.Trades', requestParameters.userWorkerTrades);
                        }
                        if (requestParameters.userPropertyIds) {
                            formParams.append('User.PropertyIds', requestParameters.userPropertyIds.join(runtime.COLLECTION_FORMATS["csv"]));
                        }
                        if (requestParameters.userLastLoginDate !== undefined) {
                            formParams.append('User.LastLoginDate', requestParameters.userLastLoginDate);
                        }
                        if (requestParameters.userRequesterViewAllEntityOrders !== undefined) {
                            formParams.append('User.RequesterViewAllEntityOrders', requestParameters.userRequesterViewAllEntityOrders);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/api/Documents",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return DocumentFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DocumentsApi.prototype.addDocument = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addDocumentRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DocumentsApi.prototype.getDocumentRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
                            throw new runtime.RequiredError('documentId', 'Required parameter requestParameters.documentId was null or undefined when calling getDocument.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Documents/{documentId}".replace("{" + "documentId" + "}", encodeURIComponent(String(requestParameters.documentId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return DocumentFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DocumentsApi.prototype.getDocument = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDocumentRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DocumentsApi.prototype.getDocumentVersionRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
                            throw new runtime.RequiredError('documentId', 'Required parameter requestParameters.documentId was null or undefined when calling getDocumentVersion.');
                        }
                        if (requestParameters.version === null || requestParameters.version === undefined) {
                            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling getDocumentVersion.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Documents/{documentId}/versions/{version}".replace("{" + "documentId" + "}", encodeURIComponent(String(requestParameters.documentId))).replace("{" + "version" + "}", encodeURIComponent(String(requestParameters.version))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return DocumentFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DocumentsApi.prototype.getDocumentVersion = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDocumentVersionRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DocumentsApi.prototype.queryDocumentsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.skip !== undefined) {
                            queryParameters['Skip'] = requestParameters.skip;
                        }
                        if (requestParameters.take !== undefined) {
                            queryParameters['Take'] = requestParameters.take;
                        }
                        if (requestParameters.processContainers !== undefined) {
                            queryParameters['ProcessContainers'] = requestParameters.processContainers;
                        }
                        if (requestParameters.fMRecordId !== undefined) {
                            queryParameters['FMRecordId'] = requestParameters.fMRecordId;
                        }
                        if (requestParameters.fMModId !== undefined) {
                            queryParameters['FMModId'] = requestParameters.fMModId;
                        }
                        if (requestParameters.documentId !== undefined) {
                            queryParameters['DocumentId'] = requestParameters.documentId;
                        }
                        if (requestParameters.propertyId !== undefined) {
                            queryParameters['PropertyId'] = requestParameters.propertyId;
                        }
                        if (requestParameters.workorderId !== undefined) {
                            queryParameters['WorkorderId'] = requestParameters.workorderId;
                        }
                        if (requestParameters.pMScheduleId !== undefined) {
                            queryParameters['PMScheduleId'] = requestParameters.pMScheduleId;
                        }
                        if (requestParameters.assetId !== undefined) {
                            queryParameters['AssetId'] = requestParameters.assetId;
                        }
                        if (requestParameters.partId !== undefined) {
                            queryParameters['PartId'] = requestParameters.partId;
                        }
                        if (requestParameters.costId !== undefined) {
                            queryParameters['CostId'] = requestParameters.costId;
                        }
                        if (requestParameters.procedureId !== undefined) {
                            queryParameters['ProcedureId'] = requestParameters.procedureId;
                        }
                        if (requestParameters.docType !== undefined) {
                            queryParameters['DocType'] = requestParameters.docType;
                        }
                        if (requestParameters.docCategory !== undefined) {
                            queryParameters['DocCategory'] = requestParameters.docCategory;
                        }
                        if (requestParameters.docTitle !== undefined) {
                            queryParameters['DocTitle'] = requestParameters.docTitle;
                        }
                        if (requestParameters.docDescription !== undefined) {
                            queryParameters['DocDescription'] = requestParameters.docDescription;
                        }
                        if (requestParameters.docStatus !== undefined) {
                            queryParameters['DocStatus'] = requestParameters.docStatus;
                        }
                        if (requestParameters.docStatusDate !== undefined) {
                            queryParameters['DocStatusDate'] = requestParameters.docStatusDate.toISOString();
                        }
                        if (requestParameters.containerData !== undefined) {
                            queryParameters['ContainerData'] = requestParameters.containerData;
                        }
                        if (requestParameters.containerFileName !== undefined) {
                            queryParameters['ContainerFileName'] = requestParameters.containerFileName;
                        }
                        if (requestParameters.nextVersionNumber !== undefined) {
                            queryParameters['NextVersionNumber'] = requestParameters.nextVersionNumber;
                        }
                        if (requestParameters.currentVersion !== undefined) {
                            queryParameters['CurrentVersion'] = requestParameters.currentVersion;
                        }
                        if (requestParameters.createdBy !== undefined) {
                            queryParameters['CreatedBy'] = requestParameters.createdBy;
                        }
                        if (requestParameters.createdDateTime !== undefined) {
                            queryParameters['CreatedDateTime'] = requestParameters.createdDateTime.toISOString();
                        }
                        if (requestParameters.modifiedDateTime !== undefined) {
                            queryParameters['ModifiedDateTime'] = requestParameters.modifiedDateTime.toISOString();
                        }
                        if (requestParameters.modifiedBy !== undefined) {
                            queryParameters['ModifiedBy'] = requestParameters.modifiedBy;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Documents",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(DocumentFromJSON); })];
                }
            });
        });
    };
    /**
     */
    DocumentsApi.prototype.queryDocuments = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queryDocumentsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return DocumentsApi;
}(runtime.BaseAPI));
export { DocumentsApi };
